var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-component',{staticClass:"scrollable",attrs:{"filter-types":_vm.filteredFilterTypes,"filter-change":_vm.filterChanged,"filter-list-change":_vm.filterListChanged,"filter-clear":_vm.filterClear,"disabled":_vm.loading,"list-sources":_vm.listSources,"my-filter-change":_vm.myFiltersChanged,"from":"students"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111d4956","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/StudentFilterContainer.vue
// module id = null
// module chunks = 